import Icon from '../components/Icon.vue'

Icon.register({
  clock: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM313.1 358.1c5.4 3.9 12.9 2.7 16.8-2.6l28.2-38.8c3.9-5.4 2.8-12.9-2.6-16.8l-63.5-46.2v-137.7c0-6.6-5.4-12-12-12h-48c-6.6 0-12 5.4-12 12v168.3c0 3.8 1.8 7.4 4.9 9.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/clock.js
// module id = 1202
// module chunks = 0